"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _Pages = _interopRequireDefault(require("composer-lib/data/model/Pages"));

var _constants = require("composer-lib/lib/constants");

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Pages.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var data = action.data,
      type = action.type;

  switch (type) {
    case _ActionTypes.default.FETCH_PAGES_PENDING:
      return state.set('status', _constants.RequestStatus.PENDING);

    case _ActionTypes.default.FETCH_PAGES_SUCCEEDED:
      return _Pages.default.fromJS(data);

    case _ActionTypes.default.FETCH_PAGES_FAILED:
      return state.set('status', _constants.RequestStatus.FAILED);

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;